import Schema from 'AppReact/schema';
import { option } from './types';

export default {
  options: Schema(option, 'array', { defaultValue: [] }),
  search: Schema('boolean', 'primitive', { defaultValue: false }),
  nullable: Schema('boolean', 'primitive', { defaultValue: false }),
  searchTerm: Schema('string', 'primitive', { defaultValue: '' }),
  selectedOptionId: Schema('integer', 'primitive-nullable', { defaultValue: null }),
  scrollLeft: Schema('integer', 'primitive-nullable', { defaultValue: null }),
  label: Schema('string', 'primitive', { defaultValue: '' }),
  isOpen: Schema('boolean', 'primitive', { defaultValue: false }),
  containerRef: Schema({}, 'object', { defaultValue: null }),
  headerRef: Schema({}, 'object', { defaultValue: null }),
  disableLabel: Schema('boolean', 'primitive', { defaultValue: false }),
  enableFullWidth: Schema('boolean', 'primitive', { defaultValue: false }),
  height: Schema('string', 'primitive', { defaultValue: '' }),
}
